/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Change_Cancel_ErrorInputs */



/**
* | output |
* | --- |
* | "The change could not be undone." |
*
* @param {Seat_Change_Cancel_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_cancel_error = /** @type {((inputs?: Seat_Change_Cancel_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Cancel_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Änderung konnte nicht zurückgenommen werden.")
	return /** @type {LocalizedString} */ ("The change could not be undone.")
});